<template>
  <div class="pageStyle">
    <div class="header">
      <div class="channelInfo">
        <div class="left">
          <img
            v-if="channelInfo.headImgUrl"
            :src="channelInfo.headImgUrl"
            alt=""
          />
          <img
            v-else
            src="https://static.xchengtech.cn/94a8116731fe40b2b8d24c0fce8dcaf0.png"
            alt=""
          />
        </div>
        <div class="right">
          <div class="item">
            <span>{{ channelInfo.name }}</span>
          </div>
          <div class="item">
            <div>
              <span>下级渠道数：</span
              ><span>{{ lowerLevelChannels.length }}</span>
            </div>
            <div>
              <span>渠道今日进件：</span><span>{{ totalOrder }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="search">
        <van-search
          v-model="query.name"
          placeholder="搜索下级渠道"
          shape="round"
          background="none"
          @input="queryName"
        />
      </div>
      <div
        v-if="lowerLevelChannelsForShow.length === 0 && !query.name"
        class="content-box"
      >
        <div
          class="item"
          v-for="(item, index) in lowerLevelChannels"
          :key="index"
        >
          <div class="left">
            <img v-if="item.headImgUrl" :src="item.headImgUrl" alt="" />
            <img
              v-else
              src="https://static.xchengtech.cn/94a8116731fe40b2b8d24c0fce8dcaf0.png"
              alt=""
            />
          </div>
          <div class="right">
            <div class="name">
              <span>{{ item.name }}</span>
              <span>{{ parseDay(item.createDateTime) }}</span>
            </div>
            <div class="msg">
              <span>今日进件数：</span>
              <span>{{
                item.channelCenter ? item.channelCenter.totalOrder : ""
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="lowerLevelChannelsForShow.length > 0" class="content-box">
        <div
          class="item"
          v-for="(item, index) in lowerLevelChannelsForShow"
          :key="index"
        >
          <div class="left">
            <img v-if="item.headImgUrl" :src="item.headImgUrl" alt="" />
            <img
              v-else
              src="https://static.xchengtech.cn/94a8116731fe40b2b8d24c0fce8dcaf0.png"
              alt=""
            />
          </div>
          <div class="right">
            <div class="name">
              <span>{{ item.name }}</span>
              <span>{{parseDay(item.createDateTime) }}</span>
            </div>
            <div class="msg">
              <span>今日进件数：</span>
              <span>{{ item.channelCenter ? item.channelCenter.totalOrder : ""}}</span>
            </div>
          </div>
        </div>
      </div>
      <van-empty
        v-if="lowerLevelChannelsForShow.length === 0 && query.name"
        description="无符合渠道"
      />
    </div>
  </div>
</template>

<script>
import {
  getXcChannelUsetCenterMsg,
  getSubChannelList,
} from "@/api/userCenter.js";
import { parseTime, parseDay } from "@/utils/index.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import Vue from "vue";
import { Search, Toast } from "vant";

Vue.use(Search);
Vue.use(Toast);
export default {
  components: {},
  watch: {},
  data() {
    return {
      channelInfo: {},
      lowerLevelChannels: [],
      lowerLevelChannelsForShow: [],
      totalOrder: 0,
      query: {
        name: "",
      },
    };
  },
  mounted() {
    this.getData();
  },
  created() {},

  methods: {
    parseDay,
    getData() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      // 获取当前渠道信息
      getCurrentChannelInfo()
        .then((res) => {
          this.channelInfo = res;
          // 获取下级渠道消息
          getSubChannelList()
            .then((ress) => {
              Toast.clear();
              ress.forEach((item) => {
                if (item.channelCenter) {
                  this.totalOrder =
                    this.totalOrder + item.channelCenter.totalOrder;
                }
              });
              this.lowerLevelChannels = ress;
            })
            .catch((errr) => {
              Toast.clear();
              console.log("errr", errr);
            });
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },

    queryName(e) {
      this.lowerLevelChannelsForShow = [];
      if (e) {
        this.lowerLevelChannels.forEach((item) => {
          if (item.name.includes(e)) {
            this.lowerLevelChannelsForShow.push(item);
          }
        });
      }
      console.log("ee", e);
    },
  },
};
</script>
<style scoped>
.pageStyle {
  min-height: 100%;
  background-color: #f4f4f4;
}
/* #1b5dd9 */
.header {
  padding: 4vw 4vw 12vw 4vw;
  background-image: linear-gradient(30deg, #1b5dd9, #3796ff);
}
.channelInfo {
  padding: 4vw 0;
  display: flex;
  gap: 4vw;
}
.channelInfo .left img {
  display: block;
  width: 16vw;
  height: 16vw;
  border-radius: 35px;
  border: 3px solid white;
}
.channelInfo .right {
  display: grid;
  color: white;
  /* gap: 1vw; */
  align-items: center;
}
.channelInfo .right .item:nth-of-type(1) {
  font-size: 6vw;
}
.channelInfo .right .item:nth-of-type(2) {
  display: flex;
  align-items: center;
  font-size: 4vw;
  gap: 4vw;
}
.content {
  margin-top: -8vw;
  border-radius: 35px 35px 0 0;
  background-color: #f4f4f4;
  padding: 5vw 4vw 4vw 4vw;
  display: grid;
  gap: 4vw;
}
.search {
}
.search .van-search {
  padding: 0;
}
.search .van-search .van-cell {
  font-size: 4vw;
  padding: 3vw 10px 3vw 0;
}
.search .van-search .van-icon {
  font-size: 4vw;
}
.search .van-search__content {
  background-color: white;
}
.content-box {
  display: grid;
  gap: 4vw;
}
.content .item {
  display: flex;
  /* align-items: center; */
  gap: 4vw;
  border-radius: 14px;
  padding: 4vw;
  background-color: white;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); */
}
.content .item .left img {
  display: block;
  width: 14vw;
  border-radius: 14px;
}

.content .item .right {
  width: 100%;
  display: grid;
  align-items: center;
}
.content .item .right .name {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content .item .right .name span:nth-of-type(1) {
  font-size: 5vw;
}
.content .item .right .name span:nth-of-type(2) {
  color: #989898;
  font-size: 3.6vw;
}
.content .item .right .msg {
  font-size: 3.6vw;
  color: #989898;
}
</style>


// WEBPACK FOOTER //
// src/view/lowerLevelChannels/index.vue